module.exports = __webpack_public_path__ + "8ac6a42e972da69855900c6ea14fe5a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/special-conditions/cuidado_especial.png
// module id = 284
// module chunks = 0